const divTenantSelector = {
  notActiveBadge: 'No está activado',
  access: 'No tiene ninguna empresa asignada',
  blocked: 'Bloqueado',
};

export default divTenantSelector;
